'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ED25519PublicKey = exports.ed25519PrivateKeyFromAsn1 = exports.ED25519PrivateKey = exports.ED25519_OID = exports.X25519_OID = undefined;

var _nodeForge = require('node-forge');

var _utils = require('../utils');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var X25519_OID = exports.X25519_OID = '1.3.101.110';
var ED25519_OID = exports.ED25519_OID = '1.3.101.112';

// ============================================================================
// ====                       ED25519 PRIVATE KEY                           ====
// ============================================================================

var ED25519PrivateKey = exports.ED25519PrivateKey = function ED25519PrivateKey() {
  var _this = this;

  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  _classCallCheck(this, ED25519PrivateKey);

  this.generate = function () {
    _this._key = _nodeForge.ed25519.generateKeyPair().privateKey;
  };

  this.publicKey = function () {
    return new ED25519PublicKey(_nodeForge.ed25519.publicKeyFromPrivateKey({ privateKey: _this._key }));
  };

  this.sign = function (message) {
    var signature = _nodeForge.ed25519.sign({
      privateKey: _this._key,
      encoding: 'binary',
      message: message
    });
    return _nodeForge.util.createBuffer(signature).getBytes();
  };

  this.toPkcs8 = function () {
    return privateKeyToPkcs8(_this._key, ED25519_OID);
  };

  if (!key) this.generate();else this._key = key;
};

var ed25519PrivateKeyFromAsn1 = exports.ed25519PrivateKeyFromAsn1 = function ed25519PrivateKeyFromAsn1(key) {
  var capture = {};
  var errors = [];
  if (!_nodeForge.asn1.validate(key, curve25519PrivateKeyValidator, capture, errors)) {
    var error = new Error('Cannot read private key. ASN.1 object does not contain an ED25519PrivateKey.');
    error.errors = errors;
    throw error;
  }

  var keyBytes = (0, _utils.stringToBytes)(capture.privateKey);
  return new ED25519PrivateKey(keyBytes);
};

// ============================================================================
// ====                        ED25519 PUBLIC KEY                           ====
// ============================================================================

var ED25519PublicKey = exports.ED25519PublicKey = function ED25519PublicKey(key) {
  var _this2 = this;

  _classCallCheck(this, ED25519PublicKey);

  this.verify = function (message, signature) {
    return _nodeForge.ed25519.verify({
      publicKey: _this2._key,
      message: message,
      encoding: 'binary',
      signature: (0, _utils.stringToBytes)(signature)
    });
  };

  this.toAsn1 = function () {
    return _nodeForge.asn1.create(_nodeForge.asn1.Class.UNIVERSAL, _nodeForge.asn1.Type.SEQUENCE, true, [
    // AlgorithmIdentifier
    _nodeForge.asn1.create(_nodeForge.asn1.Class.UNIVERSAL, _nodeForge.asn1.Type.SEQUENCE, true, [
    // algorithm
    _nodeForge.asn1.create(_nodeForge.asn1.Class.UNIVERSAL, _nodeForge.asn1.Type.OID, false, _nodeForge.asn1.oidToDer(ED25519_OID).getBytes())]),
    // subjectPublicKey
    _nodeForge.asn1.create(_nodeForge.asn1.Class.UNIVERSAL, _nodeForge.asn1.Type.BITSTRING, false,
    // We need to pad the key with the byte 0 (zero).
    _nodeForge.util.createBuffer((0, _utils.concatUint8Arrays)([0], _this2._key)).getBytes())]);
  };

  this._key = key;
};

// ============================================================================
// ====                             HELPERS                                ====
// ============================================================================

// validator for an ED25519 private key


var curve25519PrivateKeyValidator = {
  name: 'ED25519PrivateKey',
  tagClass: _nodeForge.asn1.Class.UNIVERSAL,
  type: _nodeForge.asn1.Type.OCTETSTRING,
  constructed: false,
  capture: 'privateKey'
};

var privateKeyToPkcs8 = function privateKeyToPkcs8(key, oid) {
  var asn1Key = _nodeForge.asn1.create(_nodeForge.asn1.UNIVERSAL, _nodeForge.asn1.Type.OCTETSTRING, false, _nodeForge.util.createBuffer(key).getBytes());

  return _nodeForge.asn1.create(_nodeForge.asn1.Class.UNIVERSAL, _nodeForge.asn1.Type.SEQUENCE, true, [
  // version (0)
  _nodeForge.asn1.create(_nodeForge.asn1.Class.UNIVERSAL, _nodeForge.asn1.Type.INTEGER, false, _nodeForge.asn1.integerToDer(0).getBytes()),
  // privateKeyAlgorithm
  _nodeForge.asn1.create(_nodeForge.asn1.Class.UNIVERSAL, _nodeForge.asn1.Type.SEQUENCE, true, [_nodeForge.asn1.create(_nodeForge.asn1.Class.UNIVERSAL, _nodeForge.asn1.Type.OID, false, _nodeForge.asn1.oidToDer(oid).getBytes()), _nodeForge.asn1.create(_nodeForge.asn1.Class.UNIVERSAL, _nodeForge.asn1.Type.NULL, false, '')]),
  // PrivateKey
  _nodeForge.asn1.create(_nodeForge.asn1.Class.UNIVERSAL, _nodeForge.asn1.Type.OCTETSTRING, false, _nodeForge.asn1.toDer(asn1Key).getBytes())]);
};